import React, { FC, useState, useEffect, useContext } from "react";
import Button from "../../../components/UI/button/GgButton";
import {
  DocIcon,
  SlashCircleIcon,
  CircleIcon,
  TickCircleIcon,
} from "../../../assets/icons";
import { formatDocName } from "../../../utils";
import { $public } from "../../../http";
import Spinner from "../../../components/UI/spinner/Spinner";
import { Context } from "../../..";
import { useModal } from "../../../customHooks/useModal";
import Modal from "../../../components/modal/Modal";
import Input from "../../../components/UI/input/GgInput";
import Emptiness from "../../../components/UI/emptiness/Emptiness";
import { faGlobeAsia } from "@fortawesome/free-solid-svg-icons";
import ConModal from "../../../components/comfirmationModal/ConModal";
import {showErrorToast, showSuccessToast} from "../../../components/toasts";
interface IDocsItem {
  values?: any;
  user?: any;
  pathItem?: string;
  actionData?:any
}

const AdminDoc: FC<IDocsItem> = ({ values, user, pathItem, actionData }) => {
  const [loading, setLoading] = useState<boolean>(false);

  const [docName, setDocName] = useState<string>("");
  const [documents, setDocument] = useState<File | null>(null);
  const [docFileName, setDocFileName] = useState<string>("");
  const { showModal, openModal, setModalShow, closeModal } = useModal();

  const { users } = useContext(Context)
  
  const uploadOldData = () => {
    modal.openModal()
    setDocName(formatDocName(values?.name || ""))
    setDocFileName(formatDocName(values?.documents || ""))
  }

  const reUploadFile = (e: any) => {
    if (e.target.files && e.target.files.length > 0) {
      setDocument(e.target.files[0])
      if(e.target.files[0]){
        // console.log("get file name of documents",e.target.files)
        setDocFileName(e.target.files[0].name)
      }
    }
  }

  const updateAdminDocData = async () => {
    modal.closeModal()
    
    if ((docName || documents) && pathItem) {
        
        setLoading(true);

        let formData = new FormData()
        
        const userId = users.selectedUser._id;

        formData.append('id', userId)
        formData.append('fileName', docName)
        formData.append('pathObject', pathItem)
        formData.append('file', documents as File)
          
        const data = await users.updateAdminDocument(formData)
        await loadNewUser()
        setDocFileName("")
        setDocFileName("")
        setDocument(null)
        setDocName("")
        setLoading(false);
        showSuccessToast("Upload Document successfully");
      }else{
        console.log("inval")
      }
  }

  const deleteAdminDocData = async () => {
    deleteModal.closeModal()
    if(pathItem){
      setLoading(true);
      const userId = users.selectedUser._id
      const body = {
        id: userId,
        pathObject: pathItem
      }
      await users.deleteAdminDocument(body);
      await loadNewUser()
      setLoading(false);
      showSuccessToast("Delete Document successfully");
    }

  }

  const downloadAdminDocData = () => {
    let link = document.createElement("a");
    link.target = "_blank";
    link.href = $public(
      `client/account/documents/download${values?.documents}`
    );
    link.click();
    link.remove();
  }

  async function loadNewUser() {
    const response = await users.loadOne(users.selectedUser._id);
    if (response) {
      users.setSelectedUser(response);
    }
  }
  
  const getElement = () => {
    const data = document.getElementById("file")
    data?.click()
  }
  const modal = useModal();
  const deleteModal = useModal();

  return (
    <div className="doc-card">
      <div className="doc-main">
        <Button
          icon={{ leftIcon: <DocIcon /> }}
          stylesType="round"
          className="download-btn"
          onPress={downloadAdminDocData}
        />
        <div className="doc-info">
          <div className="card-name">{formatDocName(values?.name || "")}</div>
          <div className="dates">
            <span className="created date">Added file there : {values?.added}</span>
            <span className="updated date">/ Edited: {values?.edited}</span>
          </div>
        </div>
      </div>
      {loading ? (
        <Spinner />
      ) : (
        <div className="controls">
          {actionData?.edit ? (
            <Button
            label="Modify"
            stylesType="border"
            onPress={() => uploadOldData()}
          />
          ) : "" }
          {/* TODO: Modify model open here */}
          <Modal
              show={modal.showModal}
              onClose={modal.setModalShow}
              title="Upload Files"
              showSubmit={true}
              submitLabel="Submit"
              onSubmit={updateAdminDocData}
            >
              <Input
                label="Document Name"
                type="text"
                required
                placeholder="Document Name"
                value={docName}
                onChange={(value) => setDocName(value)}
              />
              { docFileName ?
                <div style={{
                  "border": "1px solid #E5E1EC",
                  "borderRadius": "1rem",
                  "paddingInline": "1rem",
                  "outline": "none",
                  "transition": "all 0.2s ease-in-out"
                }}
                  onClick={() => getElement()}
                >
                  <div style={{ "textAlign": "center", "height": "44vh" }}>
                  <div style={{"display":"flex", "justifyContent":"center", "alignItems":"center", "height":"100%"}}>{docFileName}</div>
                  </div>
                  <label className="upload" style={{ "marginBottom": "2rem" }}>
                    <input type="file" 
                    onChange={(e) => reUploadFile(e)} 
                    id="file"
                    />
                    <span className="file-button-label">Upload File</span>
                  </label>
                </div> 
                : <div style={{
                  "border": "1px solid #E5E1EC",
                  "borderRadius": "1rem",
                  "paddingInline": "1rem",
                  "outline": "none",
                  "transition": "all 0.2s ease-in-out"
                }}
                onClick={() => getElement()}
                >
                  <div style={{ "textAlign": "center", "height": "44vh" }}>
                    <Emptiness icon={faGlobeAsia} />
                  </div>
                  <label className="upload" style={{ "marginBottom": "2rem" }}>
                    <input type="file" 
                    onChange={(e) => reUploadFile(e)} 
                    id="file"
                    />
                    <span className="file-button-label">Upload File</span>
                  </label>
                </div>
                }
            </Modal>
          {actionData?.delete ? (
            <Button 
            label="Delete"
            onPress={deleteModal.openModal}
          />
          ): ""}
          <ConModal show={deleteModal.showModal} onClose={() => deleteModal.closeModal()}  title={`Delete document #${values.name}`} onPressDelete={() => deleteAdminDocData()}>
                <div style={{marginTop:"1rem"}}>
                Are you sure you want to delete this Document !
                </div>
          </ConModal>
        </div>
      )}
    </div>
  );
};

export default AdminDoc;
